/*
 * @Author: liyxt
 * @Date: 2019-10-21 14:15:59
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 11:03:43
 * @Description: file content
 */
import React from 'react';
require('./index.less');
import CardPagination from './CardPag_test';

/**
 * @namespace CardPagination
*/

/**
 * createProps参数说明
 * @memberof CardPagination
 * @typedef createProps
 * @property {function} handlePageInfoChange 翻页按钮点击事件
 * @property {string} dataSource 卡片场景使用：缓存命名空间，单页应用缓存使用
 * @property {string} urlPkname='id' 卡片场景使用： URL中pk参数名，用于从url参数中获取当前卡片pk值
*/

/**
 * 创建翻页器组件
 * @memberof CardPagination
 * @param {createProps} props
 */
export function createCardPagination(events) {
    let _runContext = this.getQiankunContext();
    return (
        <CardPagination
            getThis={_this => {
                this.myCardPagination = _this;
            }}
            events={events}
            output={this.output}
            rootprops={this.props}
            getUrlParam={this.getUrlParam}
            _runContext={_runContext}
        />
    );
}

